
import { defineComponent, PropType, reactive, toRaw } from 'vue'
import moment from 'moment'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { GatewayClientT } from '@/core/types/gateway.types'

// composable
import useNotifications from '@/common/composable/useNotifications'

// realisations
import { gateway } from '@/core/realisations/gateway.realisation'

export default defineComponent({
    components: {
        cheap: Cheap,
        'the-button': TheButton,
    },
    props: {
        item: {
            type: Object as PropType<GatewayClientT>,
            default: null,
        },
    },
    emits: ['update', 'delete'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_token_generating: false,
        })

        const emitUpdate = () => {
            emit('update', toRaw(props.item))
        }

        const emitDelete = () => {
            emit('delete', toRaw(props.item))
        }

        const generateToken = async () => {
            if (!props.item.user_id) {
                notifications.notify({ title: 'У клиента нет user_id', type: 'danger' })
                return
            }

            try {
                state.is_token_generating = true

                const response = await gateway.generateToken(props.item.user_id, props.item.id)

                if (!navigator) {
                    notifications.notify({
                        title: 'Невозможно скопировать токен',
                        description: 'Navigator не поддерживается',
                        type: 'danger',
                    })
                    return
                }

                navigator.clipboard.writeText(response.data.access_token)
                notifications.notify({
                    title: 'Токен сгенерирован и скопирован в буффер',
                    type: 'success',
                })
            } catch (error) {
                notifications.notifyError({ error, title: 'При генерации токена произошла ошибка' })
            } finally {
                state.is_token_generating = false
            }
        }

        return { state, emitUpdate, emitDelete, generateToken, moment }
    },
})
